"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fmt = void 0;

var _package = require("../../package.json");

const fmt = (...args) => `[${_package.name}] ${args.join(' ')}`;

exports.fmt = fmt;